import type { TablePagination } from "@aurem/ui";
import { useMemo } from "react";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type UseTablePaginationProps<TFilters extends Record<string, any>> = {
  filters: TFilters;
  setFilters: (filters: Partial<TFilters>) => void;
  totalItems: number;
  pageKey: keyof TFilters;
  pageSizeKey: keyof TFilters;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useTablePagination = <TFilters extends Record<string, any>>({
  filters,
  setFilters,
  totalItems,
  pageKey,
  pageSizeKey,
}: UseTablePaginationProps<TFilters>) => {
  return useMemo(
    (): TablePagination => ({
      totalItems: totalItems,
      pageSize: Number(filters[pageSizeKey]),
      onPageSizeChange: (pageSize: number) => {
        setFilters({
          [pageSizeKey]: pageSize.toString(),
          [pageKey]: "1",
        } as Partial<TFilters>);
      },
      page: Number(filters[pageKey]),
      onPageChange: (page: number) => {
        setFilters({
          [pageKey]: page.toString(),
        } as Partial<TFilters>);
      },
      server: true,
    }),
    [filters, totalItems, setFilters, pageKey, pageSizeKey],
  );
};
